





















































import { Prop, Component, Vue } from 'vue-property-decorator'

@Component
export default class PageContent extends Vue {
    @Prop({
      default: false
    })
    loading!: Boolean

    @Prop({
      default: null
    })
    error!: String

    @Prop({
      default: false
    })
    hideLoadingText!: Boolean
}
